import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LinkStyled } from './link.styled';
import { ILinkProps } from './link.types';

export const Link: FC<ILinkProps> = ({ children, icon, ...props }) => {
  return (
    <RouterLink {...props}>
      <LinkStyled>
        {children}
        {!!icon && icon}
      </LinkStyled>
    </RouterLink>
  );
};
